export default [
  {
    path: '/admin/sale-product-deleted',
    name: 'sale-product-deleted',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/restaurant-sale/sale-product-deleted/index.vue')
  }
]
